import type { SVGProps } from 'react';
const SvgSwapHorizontalCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#swap_horizontal_circle_svg__a)">
      <path
        fill="currentColor"
        d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12s4.48 10 10 10 10-4.48 10-10Zm-7-5.5 3.5 3.5-3.5 3.5V11h-4V9h4V6.5Zm-6 11L5.5 14 9 10.5V13h4v2H9v2.5Z"
      />
    </g>
    <defs>
      <clipPath id="swap_horizontal_circle_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSwapHorizontalCircle;
